<template>
  <div class="intro page">
    
    <figure>
        <img :src="`${app_path}/images/logo.png`" alt="Logo">
        <figcaption v-html="text.title"></figcaption>
    </figure>

    <router-button mode="primary" to="game">{{ text.button_start }}</router-button>
    <router-button mode="secondary" to="tutorial">{{ text.button_tutorial }}</router-button>
    
  </div>
</template>

<script>
// @ is an alias to /src
import RouterButton from '@/components/RouterButton.vue'

export default {
  name: 'intro',
  components: {
    RouterButton
  },
  data: function() {
      return {
        text: window.config.text.intro,
        app_path: window.APP_PATH,
      };
  }
}
</script>

<style lang="scss">
.intro {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    figure {
        text-align: center;

        img {
            display: block;
            margin:0 auto 10px;
        }

        figcaption {
            text-transform: uppercase;
            font-family: 'Oswald-Light';
            font-size: 42px;
            line-height:42px;
            text-align: center;
            color: #FFF;

            small {
                display:block;
                font-size: 70%;
                font-weight:bolder;
            }
        }
    }
    
}
</style>
